import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { environment } from "../../../environments/environment";
import {
  ApiURL,
  LOGGED_IN_USER,
  LOG_LEVELS,
  USER_INFO,
} from "../../util/constants";
import { LogPublishersService } from "./log-publishers.service";
import { LogService } from "./log.service";
import { NGaugeService } from "./ngauge.service";

@Injectable()
export class AuthService {
  hasUserLoggedIn = false;
  user = {};
  redirectUrl: string;
  accessToken: any;

  constructor(
    private http: HttpClient,
    private ngaugeService: NGaugeService,
    private logService: LogService
  ) {}

  isAuthenticated(): boolean {
    return this.hasUserLoggedIn;
  }

  login(credential, mainLogin) {
    let loginURL = environment.masterUrl;
    loginURL +=
      mainLogin === true ? ApiURL.YMC_LOGIN : ApiURL.YMC_PROPERTY_LOGIN;
    return this.http
      .post(loginURL, { loginInfo: credential })
      .map((response) => {
        if (response["result"] === false) {
          return false;
        }

        const user = response["result"];
        console.log('LOGIN USER RESPONSE', user)

        if (user && user['id']) {
          localStorage.setItem('SECURE_SESSION', JSON.stringify(user));
        }

        if (!mainLogin) {
          // This is the propertylogin
          this.user["id"] = user["id"];
          this.user["SID"] = user["SID"];
          this.user["token"] = user["accessToken"];
          // adding Sid of property
          sessionStorage.setItem("sid",JSON.stringify(user['SID']))
          this.hasUserLoggedIn = true;
          sessionStorage.setItem(LOGGED_IN_USER, JSON.stringify(this.user));

          // TODO: Check if the multiproperty logic is ok
          if (response["result"]["ismultiproperty"] === "false") {
            this.ngaugeService.meldURL = response["result"]["url"];
          }
        }
        return user;
      });
  }

  switch(credential) {
    let loginURL = environment.masterUrl;
    loginURL += ApiURL.YMC_SWITCH;
    console.log(`Switch Url: ${loginURL}`)
    console.log(`Switch data: ${JSON.stringify({ loginInfo: credential })}`)
    return this.http.post(loginURL, { loginInfo: credential })
    .map((response) => {
      if (response["result"] === false) {
        return false;
      }

      const user = response["result"];
      console.log('SWITCH USER RESPONSE', user)
      if (user["result"] === false) {
        return false;
      }

      if (user && user['id']) {
        localStorage.setItem('SECURE_SESSION', JSON.stringify(user));
      }

      // This is the propertylogin
      this.user["id"] = user["id"];
      this.user["SID"] = user["SID"];
      this.user["token"] = user["accessToken"];
      // adding Sid of property
      sessionStorage.setItem("sid",JSON.stringify(user['SID']))
      this.hasUserLoggedIn = true;
      sessionStorage.setItem(LOGGED_IN_USER, JSON.stringify(this.user));

      // TODO: Check if the multiproperty logic is ok
      // if (response["result"]["ismultiproperty"] === "false") {
      //   this.ngaugeService.meldURL = response["result"]["url"];
      // }
      console.log(`RETURN USER ${JSON.stringify(user)}`);
      return user;
    });
  }

  regenerateSession(user) {
    this.user["id"] = user["id"];
    this.user["SID"] = user["SID"];
    this.user["token"] = user["accessToken"];
    this.hasUserLoggedIn = true;
    sessionStorage.setItem(LOGGED_IN_USER, JSON.stringify(this.user));
    console.log('REGENERATED SESSION!!!')
  }

  getSID () {
    return this.user["SID"];
  }

  logout() {
    const access_token = JSON.parse(sessionStorage.getItem(LOGGED_IN_USER))["token"];
    return this.http
      .post(this.ngaugeService.getMeldURL("LOGOUT"),{},{ headers: new HttpHeaders({ Authorization: access_token })})
      .subscribe(
        () => {
          this.clearAndRouteSignIn();
        },
        (error) => {
          this.clearAndRouteSignIn();
          this.logService.logError(
            LOG_LEVELS.ERROR,
            "Header Component",
            "On Logout",
            JSON.stringify(error)
          );
        }
      );
  }

  clearAndRouteSignIn() {
    this.hasUserLoggedIn = false;
    this.user["token"] = null;
    this.user["id"] = null;
    this.ngaugeService["meldURL"] = "";
    this.clearLocalVariables();
    localStorage.clear();
    sessionStorage.clear();
    console.clear();
    const logConfig = new LogPublishersService(
      this.http,
      this.logService,
      this.ngaugeService
    );
    logConfig.buildPublishers();
    this.ngaugeService.routeTo("signin");
  }

  clearSession() {
    this.hasUserLoggedIn = false;
    this.user["token"] = null;
    this.user["id"] = null;
    this.ngaugeService["meldURL"] = "";
    this.clearLocalVariables();
    localStorage.clear();
    sessionStorage.clear();
    console.clear();
  }

  clearLocalVariables() {
    this.ngaugeService["adminUsers"] = null;
    this.ngaugeService["reportAdminUsers"] = null;
    this.ngaugeService["clusterUsers"] = null;
    this.ngaugeService["functionRooms"] = null;
    this.ngaugeService["usersWithoutProperty"] = null;
  }

  forgot(email) {
    const params = { email };
    const forgotPasswordURL = environment.masterUrl + ApiURL.SEND_OTP;
    return this.http.post(forgotPasswordURL, params);
  }

  confirmationMail(ip, email, firstName, userName, changedBy) {
    const mailInfo = { email, firstName, ip, userName, changedBy };
    return this.http.post(this.ngaugeService.getMeldURL("CONFIRMATION_MAIL"), {
      mailInfo: mailInfo,
    });
  }

  // Getting user after login
  getUserById(userId, access_token, providedSID = null) {
    const SID = providedSID ? providedSID : this.getSID();
    const fields =
      '{ "where": {"SID":' + SID + ',"id":' + userId + '},"fields": ["id", "firstName", "lastName", "type", "property", "jobTitle", "email",' +
      ' "usergroup", "username", "prospectinggoal", "apptmentgoal", "grouproomgoal"] }';
    const httpOptions = {
      params: { filter: fields },
      headers: new HttpHeaders({ Authorization: access_token }),
    };
    return this.http
      .get(this.ngaugeService.getMeldURL("GETADMINDATA"), httpOptions)
      .map((result) => {
        result = result[0];
        const user = {
          id: result["id"],
          userName: `${result["firstName"]} ${result["lastName"]}`,
          loggedInUserName: result["username"],
          userType: result["type"],
          property: this.ngaugeService.isJSON(result["property"]),
          jobTitle: result["jobTitle"],
          email: result["email"],
          group: result["usergroup"],
          prospectinggoal: Number(result["prospectinggoal"]),
          apptmentgoal: Number(result["apptmentgoal"]),
          grouproomgoal: Number(result["grouproomgoal"]),
        };
        sessionStorage.setItem(USER_INFO, JSON.stringify(user));
        return user;
      });
  }

  getUserByIdAndProperty(userId, access_token, property) {
    const fields =
      '{ "where": {"property": { "like": "%' + property + '%"},"id":' + userId + '},"fields": ["id", "firstName", "lastName", "type", "property", "jobTitle", "email",' +
      ' "usergroup", "username", "prospectinggoal", "apptmentgoal", "grouproomgoal"] }';
    const httpOptions = {
      params: { filter: fields },
      headers: new HttpHeaders({ Authorization: access_token }),
    };
    return this.http
      .get(this.ngaugeService.getMeldURL("GETADMINDATA"), httpOptions)
      .map((result) => {
        result = result[0];
        const user = {
          id: result["id"],
          userName: `${result["firstName"]} ${result["lastName"]}`,
          loggedInUserName: result["username"],
          userType: result["type"],
          property: this.ngaugeService.isJSON(result["property"]),
          jobTitle: result["jobTitle"],
          email: result["email"],
          group: result["usergroup"],
          prospectinggoal: Number(result["prospectinggoal"]),
          apptmentgoal: Number(result["apptmentgoal"]),
          grouproomgoal: Number(result["grouproomgoal"]),
        };
        sessionStorage.setItem(USER_INFO, JSON.stringify(user));
        return user;
      });
  }

  getUserProfilePic(userId, providedSID = null) {
    const SID = providedSID ? providedSID : this.getSID();
    const query = '"where": {"SID":' + SID + ',"id":' + userId + '}';
    const fields = '"fields": ["id", "image"]';
    const FILTER = "{" + query + "," + fields + "}";
    const params = { params: this.ngaugeService.getHttpParams(FILTER) };
    return this.http.get(this.ngaugeService.getMeldURL("GETADMINDATA"),params);
  }

  getUser(userId, username) {
    if (username) {
      return this.http.get(this.ngaugeService.getMeldURL("GETADMINDATA") + userId + '/' + username);
    } else {
      return this.http.get(this.ngaugeService.getMeldURL("GETADMINDATA") + userId);
    }
  }

  getPropertyLogo(property) {
    const whereFilter = '"where": {"name": "' + property + '"}';
    const fields = '"fields": ["image", "id", "type"]';
    const FILTER = "{" + whereFilter + "," + fields + "}";
    const params = { params: this.ngaugeService.getHttpParams(FILTER) };
    return this.http.get(
      this.ngaugeService.getMeldURL("GET_PROPERTY_LIST"),
      params
    );
  }

  validateOtp(emailId, userOTP) {
    const params = { emailId, userOTP };
    const forgotPasswordURL = environment.masterUrl + ApiURL.VERIFY_OTP;
    return this.http.post(forgotPasswordURL, params);
  }

  verifyPassword(email, password) {
    const credential = { email, password };
    const loginURL = environment.masterUrl + ApiURL.YMC_LOGIN;
    return this.http.post(loginURL, { loginInfo: credential });
  }

  changePassword(email, password, userip) {
    const params = { email, password, userip };
    const verifyPasswordURL =
      environment.masterUrl + ApiURL.UPDATE_USER_PASSWORD;
    return this.http.post(verifyPasswordURL, params);
  }

  updateUser(updateUserDetails) {
    const changePasswordURL = environment.masterUrl + ApiURL.CHANGEPASSWORD;
    return this.http.post(changePasswordURL, { userdetail: updateUserDetails });
  }

  // For Forget Password Component
  _keyPressBlockAlpha(event: any) {
    const pattern = /[a-zA-Z~`!@#$%\^&*()+=\-_.\[\]\\';,/{}|\\":<>\?]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  captchaVerify(captchaRes) {
    const data = { response: captchaRes };
    return this.http.post(environment.masterUrl + ApiURL.VERIFY_CAPTCHA, {
      docinfo: data,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/auth.service.ts